export default {
  data() {
    return {
      levelNames: {
        0: "新手",
        1: "普通",
        2: "良好",
        3: "优秀",
        4: "完美",
        5: "专业",
        6: "黄金",
        7: "铂金",
        8: "钻石",
        9: "专家",
        10: "国王",
      },
      gameNameHash: {
        1: "怪兽消消乐",
        2: "合成大西瓜",
      },
    };
  },
  filters: {
    level2name(val, T, levelNames) {
      return T(levelNames[val]);
    },
  },
  methods: {
    getGameName(id) {
      return this.T(this.gameNameHash[id]);
    },
  },
};
